import {
  ArrowRightStartOnRectangleIcon,
  LinkIcon,
} from "@heroicons/react/24/outline";
import { BgImage, SmartLink, useProfile } from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";
import { Outlet } from "@remix-run/react";
import { twJoin } from "tailwind-merge";

export default function Account() {
  const profile = useProfile();
  return (
    <div>
      <BgImage
        className="bg-netural-500 h-screen max-h-[400px] w-full print:hidden"
        src={profile.cover || t(routes.mission, "image")}
      />
      <header className="border-b bg-neutral-100 print:hidden">
        <div
          className={twJoin(
            "container flex",
            "flex-col-reverse md:flex-row",
            "items-center md:items-start",
            "justify-between",
          )}
        >
          <div className="px-4 py-8">
            <h2 className="text-xl uppercase tracking-widest text-[#343030]">
              My account
            </h2>
            <h3 className="text-neutral-500">{profile.name}</h3>
          </div>
          <BgImage
            src={profile.logo}
            className="relative -mt-20 size-40 rounded-full shadow"
          />
        </div>
      </header>
      <div
        className={twJoin(
          "container mb-20 flex gap-6",
          "flex-col lg:flex-row",
          "items-center lg:items-start",
          "print:mb-0 print:block print:max-w-full print:divide-x-0 print:px-0 print:py-4",
        )}
      >
        <nav
          className={twJoin(
            "print:hidden",
            "flex flex-col",
            "w-full lg:max-w-60",
            "text-xs font-light uppercase tracking-wide text-neutral-500",
            "rounded-b-lg bg-neutral-100",
          )}
        >
          {[
            "/account",
            "/account/moodboards",
            "/account/details",
            "/account/visualiser",
            "/account/logout",
          ].map((k) => (
            <SmartLink
              to={k}
              key={k}
              end={!k.match("moodboards")}
              preventScrollReset
              className={twJoin(
                "flex items-center justify-between gap-2 p-4",
                "border-b last:border-b-0",
                "hover:text-black",
                "[&.active]:bg-neutral-50",
                "[&.active]:text-black",
              )}
              target={k.match("visualiser") ? "_blank" : undefined}
            >
              <span> {k === "/account" ? "Welcome" : t(k, "title")}</span>
              {k.match("visualiser") && <LinkIcon className="size-4" />}
              {k.match("logout") && (
                <ArrowRightStartOnRectangleIcon className="size-4" />
              )}
            </SmartLink>
          ))}
        </nav>
        <div className="w-full flex-1 pt-4 lg:pt-10 print:flex-none print:p-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
